import script from "./QueueTicketPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueTicketPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueueTicketPage.vue?vue&type=style&index=0&id=ebae9942&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebae9942"]])

export default __exports__